import React from "react";
import Index from "../Index";

export default function PrimaryButton(props) {
  return (
    <>
      <Index.Box className="primary-btn-main">
        <Index.Button
          className={props.className}
          type={props.type}
          onClick={props.onClick}
          disabled={props.disabled}
        >
          {props.btnLabel}
        </Index.Button>
      </Index.Box>
    </>
  );
}
